const PROGRAMS_CACHE_KEYS = {
  RECOMMENDATIONS: 'programs-recommendations',
  LIVE_PROGRAM: 'programs-live',
  EXERCISE_SUMMARY: 'programs-exercise-summary',
  SLEEP_SUMMARY: 'programs-sleep-summary'
}

export const getCachedRecommendations = (personId, date) => {
  const cacheKey = `${PROGRAMS_CACHE_KEYS.RECOMMENDATIONS}-${personId}-${date}`
  const cachedData = localStorage.getItem(cacheKey)
  if (cachedData) {
    try {
      const recommendationsData = JSON.parse(cachedData)

      // Check if cache has expired (TTL: 1 day = 86400000ms)
      const cacheAge = Date.now() - (recommendationsData._cachedAt || 0)
      const TTL = 24 * 60 * 60 * 1000 // 1 day in milliseconds

      if (cacheAge > TTL) {
        localStorage.removeItem(cacheKey)
        return null
      }

      return recommendationsData
    } catch (err) {
      localStorage.removeItem(cacheKey)
      return null
    }
  }
  return null
}

export const setCachedRecommendations = (
  personId,
  date,
  recommendationsData,
) => {
  const cacheKey = `${PROGRAMS_CACHE_KEYS.RECOMMENDATIONS}-${personId}-${date}`
  try {
    localStorage.setItem(
      cacheKey,
      JSON.stringify({
        ...recommendationsData,
        _cachedAt: Date.now()
      }),
    )
  } catch (err) {
    // Silent failure - caching is optional
    console.error('Failed to cache recommendations data:', err)
  }
}

export const getCachedLiveProgram = (personId, weekRange) => {
  const cacheKey = `${PROGRAMS_CACHE_KEYS.LIVE_PROGRAM}-${personId}-${weekRange}`
  const cachedData = localStorage.getItem(cacheKey)
  if (cachedData) {
    try {
      const liveProgramData = JSON.parse(cachedData)

      // Check if cache has expired (TTL: 30 minutes = 1800000ms)
      const cacheAge = Date.now() - (liveProgramData._cachedAt || 0)
      const TTL = 30 * 60 * 1000 // 30 minutes in milliseconds

      if (cacheAge > TTL) {
        localStorage.removeItem(cacheKey)
        return null
      }

      return liveProgramData
    } catch (err) {
      localStorage.removeItem(cacheKey)
      return null
    }
  }
  return null
}

export const setCachedLiveProgram = (personId, weekRange, liveProgramData) => {
  const cacheKey = `${PROGRAMS_CACHE_KEYS.LIVE_PROGRAM}-${personId}-${weekRange}`
  try {
    localStorage.setItem(
      cacheKey,
      JSON.stringify({
        ...liveProgramData,
        _cachedAt: Date.now()
      }),
    )
  } catch (err) {
    // Silent failure - caching is optional
    console.error('Failed to cache live program data:', err)
  }
}

export const clearProgramsCache = (personId) => {
  // Clear all program caches for this person
  const keysToRemove = []
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i)
    if (
      key &&
      key.includes(personId) &&
      (key.startsWith(PROGRAMS_CACHE_KEYS.RECOMMENDATIONS) ||
        key.startsWith(PROGRAMS_CACHE_KEYS.LIVE_PROGRAM) ||
        key.startsWith(PROGRAMS_CACHE_KEYS.EXERCISE_SUMMARY) ||
        key.startsWith(PROGRAMS_CACHE_KEYS.SLEEP_SUMMARY))
    ) {
      keysToRemove.push(key)
    }
  }
  keysToRemove.forEach((key) => localStorage.removeItem(key))
}
